import { usePerplexityExtensionAvailable } from '#pplx/frontend/comet/client/perplexityExtension.js';
import { useFeatureFlags } from '#pplx/frontend/experimentation/hooks.js';
export function useWebBrowserExtensionTransportEnabled() {
    const { getFlagValue } = useFeatureFlags();
    return getFlagValue({ flag: 'computer-web-extension-transport', defaultValue: false });
}
export function useWebBrowserExtensionAvailable() {
    return usePerplexityExtensionAvailable(useWebBrowserExtensionTransportEnabled());
}
//# sourceMappingURL=useWebBrowserExtensionAvailable.js.map